export const environment = {
  production: true,
  apiUrl: 'https://studio-ip-887725881421.asia-south2.run.app/v1/',
  vendorLogin: 'https://dev-contributor.mahatta.com/api/api/unauth/login ',
  geminiApiKey: 'AIzaSyCqX-wYXA4EieB0JwmFdygBbz7ruz8xuhM',
  vendorApiBase: 'https://dev-contributor.mahatta.com',
  vendorBaseUri: 'https://dev-contributor.mahatta.com/api/api',
  gcsBucket: 'static-mahatta-com',
  sseBaseUri: 'https://sse-uat.studioip.ai/api',
  sseApiKey: 'sse-studioip-2026-secure',
  supportWhatsappNumber: '919599941024',
  supportContactName: 'Monika',
  restrictedMenuEmails: ['prodcontroller@studioip.ai'],
  commsHubEmails: ['prodcontroller@studioip.ai'],
  hiddenVendorReportsEmails: ['sandeep@studioip.ai'],
  analytics: {
    mixpanelToken: '95810ef5e247d2719ede49c63df8e7ea',
    mixpanelRegion: 'us' as 'us' | 'eu' | 'in',
    ga4MeasurementId: 'G-XX0L4V9PR6',
    debug: true,
    ignoreDoNotTrack: false,
  },
};
